import { IFacilityReitItem } from "../../../components/pages/reitFacility/components/map";
import fetcher from "../../../lib/fetcher";
import useSWRMutation from "swr/mutation";
import {
  FacilityListItemSchema,
  FacilityListOnBuildingItemSchemaResponseWrapper,
} from "./types";
import { getImgFromObjectFacility } from "../../../lib/utils";

const ERROR_MESSAGE = "Не удалось получить данные для карты";

const useReitListByBuilding = <T extends boolean | undefined = undefined>(
  buildingId: number | null,
  isTransform?: T
) => {
  async function fetchMapReitListByBuilding(
    url: string,
    { arg }: { arg: { typeIds: number[] } }
  ) {
    try {
      if (buildingId) {
        const data =
          await fetcher.swr<FacilityListOnBuildingItemSchemaResponseWrapper>(
            url,
            {
              method: "POST",
              data: { typeIds: arg.typeIds.length ? arg.typeIds : undefined },
            }
          );

        return data.data as FacilityListItemSchema;
      }
    } catch (error) {
      console.log(error, ERROR_MESSAGE);
      throw ERROR_MESSAGE;
    }
  }

  const { data, error, isMutating, trigger } = useSWRMutation(
    `/building/${buildingId}/facility-list`,
    fetchMapReitListByBuilding
  );

  const transformList = (): IFacilityReitItem[] => {
    return data?.facilities.map((reitItem) => {
      const imgs = getImgFromObjectFacility(reitItem);
      return {
        address: data.title,
        id: reitItem.id,
        price: reitItem.currentPrice,
        title: reitItem.title,
        img: {
          url: imgs[imgs.length - 1]?.src,
          name: imgs[imgs.length - 1]?.alt,
        },
      };
    }) as IFacilityReitItem[];
  };

  const transformed = isTransform ? transformList() ?? [] : data ?? [];

  type TReitList = T extends true
    ? IFacilityReitItem[]
    : FacilityListItemSchema;

  return {
    reitList: transformed as TReitList,
    error,
    isMutating,
    trigger,
  };
};

export default useReitListByBuilding;
